import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { v4 as uuidv4 } from "uuid";
import { getKlaviyoData } from "../../../../../helper/Integration/klaviyo";

const AuthModal = ({ setOpen, integrationData, setIntegrationData, setValidAuth }) => {
  const [authName, setAuthName] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setAuthName(`${uuidv4()} Klaviyo account`);
    if(integrationData?.data){
      setAuthName(integrationData?.auth_name);
      setApiKey(integrationData?.api_key);
    }
  }, [integrationData]);

  const AuthHandler = async () => {
    if (!authName || !apiKey) {
      setError("Please fill all the fields");
      return;
    }
    setLoading(true);
    try {
      const data = await getKlaviyoData(apiKey);
      if (data) {
        setIntegrationData({
          name: "Klaviyo",
          auth_name:
            data?.data?.data[0]?.attributes?.contact_information?.organization_name,
          data: data?.data,
          listData: data?.listData,
          api_key: apiKey,
        });
        setValidAuth(true);
        setOpen(false);
        setError("");
      } else {
        setError("Please enter a valid API key");
        return;
      }
      setLoading(false);
    } catch (error) {
      setError(error.message);
      setLoading(false);
      return;
    }
  };
  return (
    <div className="bg-gray-800/30 text-black w-[100%] min-h-[500px] p-5 absolute inset-0 z-10">
      <div className="flex items-center justify-center">
        <div className="bg-white rounded-md p-3 basis-2/3 relative">
          <RxCross2
            className="absolute right-3 hover:cursor-pointer"
            onClick={() => setOpen(false)}
          />
          <h2 className="text-2xl font-semibold my-3 mb-4">
            Create a new authentication
          </h2>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <label className="text-semibold">Your authentication name</label>
              <input
                type="text"
                value={authName}
                className="rounded-md text-sm border-gray-200 text-gray-500"
                onChange={(e) => setAuthName(e.target.value)}
              />
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-semibold">API Key</label>
              <input
                type="text"
                value={apiKey}
                className="rounded-md text-sm border-gray-200 text-gray-500"
                onChange={(e) => setApiKey(e.target.value)}
              />
            </div>
          </div>
          {error && <div className="text-red-500 text-sm my-2">{error}</div>}

          <div className="mt-20 space-x-3 flex justify-end ">
            <button
              className="text-gray-800 rounded-md p-2 px-3 border hover:text-indigo-600 hover:shadow-lg"
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>
            <button
              onClick={AuthHandler}
              className="text-white rounded-md bg-indigo-600 p-2 px-3 hover:bg-indigo-500"
            >
              {loading ? "Loading..." : "Create"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
